import { withChildren } from '@builder.io/react';
import { JSX } from 'react';

import { Text as TextComponent, TextProps, FontWeight } from '@videoblocks/design-system';

interface TextBuilderProps extends TextProps {
    text: string;
    fontColor?: string;
    fontWeight?: FontWeight;
    htmlElement?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Text = ({ text, fontSize, fontFamily, fontColor, fontWeight, htmlElement }: TextBuilderProps) => {
    const ElementTag = (htmlElement || 'span') as keyof JSX.IntrinsicElements;

    return (
        <TextComponent fontSize={fontSize} fontFamily={fontFamily} fontWeight={fontWeight} asChild>
            <ElementTag style={{ color: fontColor }}>{text}</ElementTag>
        </TextComponent>
    );
};
export default withChildren(Text);
